import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Stack, Typography } from '@mui/material';

import { Loader } from '../../../atoms/loader/Loader';
import { Star } from '../../../atoms/Star';
import { MplPaper } from '../../../molecules/MplPaper';

import { useDriverFeedbackContext } from './DriverFeedbackProvider';

interface IRatingBlockProps {
	rating: number;
	countOfReviews: number;
}

export const RatingBlock: FC<IRatingBlockProps> = ({
	rating,
	countOfReviews,
}) => {
	const { t } = useTranslation('profile');
	const { isLoading } = useDriverFeedbackContext();

	const ratingArr = useMemo(
		() =>
			new Array(5)
				.fill(0)
				.map((_, index) => (index + 1 <= rating ? 1 : rating - index)),
		[rating]
	);

	return (
		<MplPaper alignItems="center" gap={1}>
			<Stack gap={0.5} alignItems="center">
				<Typography variant="title" color="primary.main">
					{Math.round(rating * 10) / 10}/5
				</Typography>
				<Stack direction="row" gap={0.5}>
					{ratingArr.map((value, index) => (
						<Star key={index} filledOn={value} />
					))}
				</Stack>
			</Stack>
			<Typography variant="body2" fontWeight={600} textAlign="center">
				{t('feedback.average', { count: countOfReviews })}
			</Typography>
			<Collapse in={isLoading}>
				<Loader />
			</Collapse>
		</MplPaper>
	);
};
